export type PriceType = "fixed" | "from" | "quote";
export type ProductStatus = "available" | "made-to-order" | "previously-created" | "temporarily-unavailable";

export type CategorySlug = "pens" | "lathe-gifts" | "cnc" | "other" | "pen-turners";

export interface ProductImage {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export interface Product {
  id: string;
  slug: string;
  name: string;
  internalCode: string;
  category: CategorySlug;
  subcategory: string;
  shortDescription: string;
  fullDescription: string;
  story?: string;
  price: number | null;
  priceType: PriceType;
  status: ProductStatus;
  materials: string[];
  finishes: string[];
  dimensions?: string;
  turnaround?: string;
  shippingNotes?: string;
  customizable: boolean;
  featured: boolean;
  images: ProductImage[];
  tags: string[];
  occasions: string[];
  relatedProducts: string[];
  seoTitle: string;
  seoDescription: string;
}

export const statusLabels: Record<ProductStatus, string> = {
  available: "Available",
  "made-to-order": "Made to Order",
  "previously-created": "Previously Created",
  "temporarily-unavailable": "Temporarily Unavailable",
};

export function formatPrice(product: Pick<Product, "price" | "priceType">) {
  if (product.priceType === "quote" || product.price == null) return "Price on request";
  const value = `$${product.price.toLocaleString("en-US")}`;
  return product.priceType === "from" ? `From ${value}` : value;
}

export function img(src: string, alt: string, width = 1200, height = 900): ProductImage {
  return { src, alt, width, height };
}
